import { createContext } from "react";
import type { RecipientTokenAdapter } from "./types";
import { MockRecipientTokenAdapter } from "./mock/mockAdapter";
import { LiveRecipientTokenAdapter } from "./live/liveAdapter";

/**
 * Recipient token-adapter selection + context (spec §8), kept component-free so
 * the Provider (adapters.tsx) and the hook (use-adapter.ts) satisfy
 * react-refresh/only-export-components. Mirrors the signals adapter split.
 *
 * Env-driven (W2 live wiring). `VITE_RECIPIENT_ADAPTER_MODE=live` binds the
 * token surface to the deployed v08 magic-link functions; anything else —
 * including unset (the default for tests and the mock screenshot harness) —
 * keeps the in-memory mock adapter.
 */
export type RecipientAdapterMode = "mock" | "live";

export const RECIPIENT_ADAPTER_MODE: RecipientAdapterMode =
  import.meta.env.VITE_RECIPIENT_ADAPTER_MODE === "live" ? "live" : "mock";

function selectRecipientAdapter(): RecipientTokenAdapter {
  return RECIPIENT_ADAPTER_MODE === "live"
    ? new LiveRecipientTokenAdapter()
    : new MockRecipientTokenAdapter();
}

export const defaultRecipientAdapter = selectRecipientAdapter();

export const RecipientAdapterContext =
  createContext<RecipientTokenAdapter>(defaultRecipientAdapter);
